<template>
  <div class="follow" v-if="list != undefined">
    <div class="follow-title">
      <div class="manager">
        <img src="../../assets/user/manager.png" alt="" />
        <span>{{ $t('label.Account_Manager') }}</span>
      </div>
      <div>
        <el-tooltip class="item" effect="light" :content="$t('message.Change_Account_Manager')" placement="top-start">
          <div @click="genghuan" class="tiaohuan">
            <i class="el-icon-sort"></i>
          </div>
        </el-tooltip>
      </div>
    </div>
    <div class="name">
      <div>{{ $t('common.Name') }}:</div>
      <div class="name1">{{ list.memberName }}</div>
    </div>
    <div class="name">
      <div class="">{{ $t('label.Manager_Mobile_phone_number') }}:</div>
      <div class="name1">{{ list.phone }}</div>
    </div>
  </div>
</template>

<script>
import { post, get } from '@/utils/request'
export default {
  data() {
    return {
      list: ''
    }
  },
  created() {
    this.getmanager()
  },
  methods: {
    getmanager() {
      get('api/account/getMyManagerInfo').then((res) => {
        this.list = res.data.data
      })
    },
    genghuan() {
      this.$confirm(this.$t('confirm.Confirm_to_replace_the_exclusive_manager'), this.$t('common.Confirmation'), {
        confirmButtonText: this.$t('button.Confirm'),
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        get('api/account/checkOrderIsNotFinishedByMemberId').then((res) => {
          if (res.data.data == true) {
            this.$message.warning({
              message: this.$t('message.Please_complete_the_current_order_first')
            })
          } else if (res.data.data == false) {
            this.savemanager()
          }
        })
      })
    },
    savemanager() {
      get('api/account/saveApplyAdjustManager').then((res) => {
        if (res.data.msg == '0') {
          this.$message.success({
            message: this.$t('message.Application_successful')
          })
        } else {
          this.$message.error({
            message: this.$t('message.Application_failed')
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.follow {
  height: auto;
  width: 291px;
  background: #fff;

  &-title {
    height: 35px;
    padding: 5px;
    padding-left: 20px;
    padding-right: 10px;
    color: #606060;
    font-weight: 600;
    font-size: 18px;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .manager {
      display: flex;
      align-items: center;
      span {
        margin-left: 7px;
      }
      img {
        width: 25px;
        height: 25px;
      }
    }
    .tiaohuan {
      cursor: pointer;
    }
  }
  .name {
    height: 35px;
    padding: 3px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    .name1 {
      margin-left: 10px;
    }
  }
}
</style>
